import React, { Component } from 'react';

import { Page, Button, Card } from '@shopify/polaris';

// import OnPageSEOTabs from '../Tabs';
import errorImg from './images/500-internal-server-error.png';
import './index.css';
import { store } from '../../../redux/store';
import Language from '../../../i18n/Language';
const t = Language;

class Error extends Component {

  render() {

    const pageContent = <div className='error_block'>
      <div className="not-img">
        <img src={errorImg} alt="page not found" className="error-img"></img>
      </div>
      <div className="page-error">
        <div className="not-found-title">
          {t("Sorry, Internal Server Error")}
        </div>
        <div className="not-found-msg">
          {t("Please try navigating to the page from SEO Ant Home and try again.")}
        </div>
        <Button variant="primary" size="large" url="/dashboard">{t("Go to SEO Ant Home")}</Button>
      </div>
    </div>;

    const embed = store.getState().public.isShowTopMenu;

    return (
      <div id="SEOpage_content" style={{ paddingLeft: `${window.isExpandedNav && embed ? '15rem' : '3.8rem'}`, maxWidth: '100%' }}>
        <title>SEOAnt - 500</title>
        <Page>
          <Card>{pageContent}</Card>
        </Page>
      </div>
    );
  }
}

export default Error;
